import "../../../css/Containers/ContainerStyles.css";
import { Colors } from "../../../utils/colors";
import PopupModalContainer, {
  PopupModalContainerWidth,
} from "../PopupModalContainer";
import RectangleButton from "../../Buttons/RectangleButton";
import { ThemeStyle } from "../../../hooks/useTheme";
import React, { ReactNode } from "react";

type ConfirmActionModalProps = {
  heading: string;
  subtext?: string | ReactNode;
  confirmButtonText: string;
  hideModal: boolean;
  setIsVisible: (isVisible: boolean) => void;
  confirmOnPress: () => Promise<void> | void;
  cancelOnPress?: () => void;
  disableConfirm?: boolean;
  loadingConfirm?: boolean;
  icon?: ReactNode;
  alternateConfirmBtn?: ReactNode;
  altConfirmBtnColor?: string;
  theme?: ThemeStyle;
};

// Used as a replacement to browser window.confirm to confirm an action or cancel
const ConfirmActionModal = (props: ConfirmActionModalProps) => {
  const {
    heading,
    subtext,
    confirmButtonText,
    hideModal,
    setIsVisible,
    confirmOnPress,
    cancelOnPress,
    disableConfirm,
    loadingConfirm,
    icon,
    alternateConfirmBtn,
    altConfirmBtnColor,
    theme,
  } = props;

  return (
    <PopupModalContainer
      headerComp={
        <div className="ColumnNormal" style={{ gap: 4 }}>
          {icon}
          <span style={{ fontSize: 16, fontWeight: "500" }}>{heading}</span>
        </div>
      }
      subHeaderComp={
        <div>
          {subtext ? (
            (subtext as string) ? (
              <span
                style={{
                  fontSize: 14,
                  color: Colors.GRAY1,
                  whiteSpace: "none",
                }}
              >
                {subtext}
              </span>
            ) : (
              subtext
            )
          ) : null}
        </div>
      }
      valueComp={
        <div className="RowNormal" style={{ gap: 14 }}>
          <RectangleButton
            buttonLabel="Cancel"
            onPress={() => {
              if (cancelOnPress) {
                cancelOnPress();
              }
              setIsVisible(false);
            }}
            disabled={loadingConfirm}
            altTextColor={Colors.BLACK}
            altColor={Colors.GRAY6}
            altPaddingVert={14}
          />
          {alternateConfirmBtn ?? (
            <RectangleButton
              buttonLabel={confirmButtonText}
              onPress={async () => {
                await confirmOnPress();
                setIsVisible(false);
              }}
              disabled={disableConfirm}
              loading={loadingConfirm}
              altTextColor={Colors.WHITE}
              altColor={altConfirmBtnColor ?? Colors.BLACK}
              altPaddingVert={14}
            />
          )}
        </div>
      }
      noExit
      closeModal={() => {}}
      hideModal={hideModal}
      theme={theme}
      modalContentWidth={PopupModalContainerWidth.SMALL}
    />
  );
};

export default ConfirmActionModal;
